import styled from '@emotion/styled/macro';

export const HeaderActionsContainer = styled.div`
  display: flex;
  gap: 2rem;
`;
